if (!customElements.get('product-addon')) {
  customElements.define(
    'product-addon',
    class ProductAddon extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.productFormId = this.dataset.productFormId;
        this.checkbox = this.querySelector('[data-addon-toggle]');
      }

      connectedCallback() {
        if (!this.variantId || !this.checkbox || !this.productFormId) return;

        this.form = document.getElementById(this.productFormId);
        if (!this.form) return;

        this.productFormElement = this.form.closest('product-form');
        this.interceptTarget = this.productFormElement || this.form.parentElement;
        if (!this.interceptTarget) return;

        this.boundSubmit = this.onCaptureSubmit.bind(this);
        this.interceptTarget.addEventListener('submit', this.boundSubmit, { capture: true });
      }

      disconnectedCallback() {
        if (this.interceptTarget && this.boundSubmit) {
          this.interceptTarget.removeEventListener('submit', this.boundSubmit, { capture: true });
        }
      }

      onCaptureSubmit(evt) {
        if (evt.target !== this.form) return;
        if (!this.checkbox.checked) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();

        this.addBundle();
      }

      addBundle() {
        const submitButton = this.form.querySelector('[type="submit"]');
        if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

        const mainIdInput = this.form.querySelector('input[name="id"]');
        if (!mainIdInput || !mainIdInput.value) return;

        const mainVariantId = mainIdInput.value;
        const qtyInput = this.form.elements.namedItem('quantity');
        const mainQuantity = qtyInput && qtyInput.value ? qtyInput.value : 1;

        const cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const formData = new FormData();
        formData.append('items[0][id]', mainVariantId);
        formData.append('items[0][quantity]', mainQuantity);
        formData.append('items[1][id]', this.variantId);
        formData.append('items[1][quantity]', '1');

        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        this.setLoading(true);
        if (this.productFormElement && typeof this.productFormElement.handleErrorMessage === 'function') {
          this.productFormElement.handleErrorMessage();
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (
                this.productFormElement &&
                typeof this.productFormElement.handleErrorMessage === 'function'
              ) {
                this.productFormElement.handleErrorMessage(response.description);
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-addon',
                  productVariantId: mainVariantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-addon',
                productVariantId: mainVariantId,
                cartData: response,
              });
            }

            cart.renderContents(response);
            this.checkbox.checked = false;
          })
          .catch((e) => {
            console.error('product-addon: bundled add failed', e);
          })
          .finally(() => {
            this.setLoading(false);
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          });
      }

      setLoading(isLoading) {
        const submitButton = this.form.querySelector('[type="submit"]');
        const spinner = this.form.querySelector('.loading__spinner');

        if (isLoading) {
          if (submitButton) {
            submitButton.classList.add('loading');
            submitButton.setAttribute('aria-disabled', 'true');
          }
          if (spinner) spinner.classList.remove('hidden');
        } else {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
        }
      }
    }
  );
}
